/* eslint-disable */
const mockedFlightDetails = {
    flightDetails: {
        flightsOfDeparture: [{
            airline: "EK",
            flightNo: "377",
            stops:"2",
            origin: {
                airport: {
                    code: "BKK",
                    name: "Bangkok Suvarnabhumi",
                    terminal: ""
                },
                day: "Fri",
                date: "20191101",
                time: "330",
            },
            destination: {
                airport: {
                    code: "DXB",
                    name: "Dubai International",
                    terminal: "3"
                },
                day: "Fri",
                date: "20191101",
                time: "715",
            },
        },
        {
            airline: "EK",
            flightNo: "201",
            stops:"2",
            origin: {
                airport: {
                    code: "DXB",
                    name: "Dubai International",
                    terminal: "3"
                },
                day: "Fri",
                date: "20191101",
                time: "830",
            },
            destination: {
                airport: {
                    code: "JFK",
                    name: "New York John F Kennedy",
                    terminal: "4"
                },
                day: "Fri",
                date: "20191101",
                time: "1425",
            }
        }
        ],
        flightsOfReturn: [{
            airline: "EK",
            flightNo: "210",
            stops:"2",
            origin: {
                airport: {
                    code: "EWR",
                    name: "New York Newark",
                    terminal: "B"
                },
                day: "Sat",
                date: "20191130",
                time: "2355",
            },
            destination: {
                airport: {
                    code: "ATH",
                    name: "Athens",
                    terminal: "3"
                },
                day: "Sun",
                date: "20191201",
                time: "1610",
            },
        },
        {
            airline: "EK",
            flightNo: "210",
            stops:"2",
            origin: {
                airport: {
                    code: "ATH",
                    name: "Athens",
                    terminal: "B"
                },
                day: "Sun",
                date: "20191201",
                time: "1755",
            },
            destination: {
                airport: {
                    code: "DXB",
                    name: "Dubai International",
                    terminal: "3"
                },
                day: "Mon",
                date: "20191201",
                time: "20",
            },
        },
        {
            airline: "EK",
            flightNo: "376",
            stops:"2",
            origin: {
                airport: {
                    code: "DXB",
                    name: "Dubai International",
                    terminal: "3"
                },
                day: "Mon",
                date: "20191202",
                time: "330",
            },
            destination: {
                airport: {
                    code: "BKK",
                    name: "Bangkok Suvarnabhumi",
                    terminal: "3"
                },
                day: "Mon",
                date: "20191202",
                time: "1235",
            },
        }        
        ]
    }
}

const mockedFlightDetails2 = {
    flightDetails: {
        flightsOfDeparture: [
        ],
        flightsOfReturn: [
        ]
    }
}

export default mockedFlightDetails2